module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 51
// module chunks = 0